import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"
import tippy from "tippy.js"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.initializeTooltip()
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.destroy()
    }
  }

  async initializeTooltip() {
    // Create a container for the QR code
    const qrContainer = document.createElement('div')
    qrContainer.classList.add('qr-tooltip-content')
    
    // Generate QR code
    try {
      const canvas = document.createElement('canvas')
      await QRCode.toCanvas(canvas, this.urlValue, {
        width: 200,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      })
      
      // Add title and canvas to container
      const title = document.createElement('p')
      title.textContent = 'Scan with mobile device'
      title.classList.add('text-sm', 'font-medium', 'mb-2', 'text-center')
      
      qrContainer.appendChild(title)
      qrContainer.appendChild(canvas)
      
      // Add deep link text
      const linkText = document.createElement('p')
      linkText.textContent = this.urlValue
      linkText.classList.add('text-xs', 'text-gray-500', 'mt-2', 'break-all', 'max-w-xs')
      qrContainer.appendChild(linkText)
      
    } catch (error) {
      console.error('Error generating QR code:', error)
      qrContainer.textContent = 'Error generating QR code'
    }

    // Create tooltip with Tippy.js
    this.tooltip = tippy(this.element, {
      content: qrContainer,
      trigger: 'mouseenter',
      interactive: true,
      placement: 'bottom',
      theme: 'light-border',
      maxWidth: 250,
      animation: 'scale',
      appendTo: document.body
    })
  }
}